module.exports = __webpack_public_path__ + "school/img/shipingpeixun3ji.f446685c.jpg";